import { getDefaultValue } from '@draftkings/sportsbook-common-utils';
import type * as ContractTypes from '@draftkings/dk-data-layer';
import { NavLinkProps } from '../../../../types/window';

export const getRenderNavLink = (
    event: ContractTypes.SportEvent,
    renderNavLink: (props: NavLinkProps) => JSX.Element,
    buildNavLink: (eventId: string, seoIdentifier: string) => string,
    ariaLabel?: string
) => {
    return (props: { children: React.ReactNode }) =>
        renderNavLink({
            children: props.children,
            url: buildNavLink(event.id, getDefaultValue(event.seoIdentifier, '')),
            ariaLabel
        });
};
